import { render, staticRenderFns } from "./mpsz.vue?vue&type=template&id=68f0c3be&scoped=true&"
import script from "./mpsz.vue?vue&type=script&lang=js&"
export * from "./mpsz.vue?vue&type=script&lang=js&"
import style0 from "./mpsz.vue?vue&type=style&index=0&id=68f0c3be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f0c3be",
  null
  
)

export default component.exports